import { Slider } from 'baseui/slider'
import * as React from 'react'
import { WemoloTypography } from '../Wemolo'
import styles from './Slider.module.css'

type SliderComponentProps = {
    max: number
    setValue: (key: string, value: number | number[]) => void
    value_view: number[]
}

export const SliderComponent = ({ max, setValue, value_view }: SliderComponentProps) => {
    return (
        <Slider
            value={value_view}
            min={0}
            max={max}
            step={1}
            onChange={({ value }) => {
                setValue('view_trajectories', value)
            }}
            // onFinalChange={({ value }) => {
            //     setValue('view_trajectories', value)
            // }}
            overrides={{
                Root: {
                    style: {
                        paddingTop: '20px',
                        backgroundColor: 'rgb(238, 238, 238)',
                        borderRadius: '5px'
                    }
                },
                Thumb: {
                    style: {
                        outline: 'none',
                        width: '18px',
                        height: '18px'
                    }
                },
                Tick: {
                    style: {
                        fontSize: '12px'
                    }
                },
                InnerThumb: () => null,
                ThumbValue: ({ $value, $thumbIndex }) => (
                    <WemoloTypography variant="label-xsmall" tag="div" className={styles.thumbValue}>
                        {$thumbIndex === 0 ? $value[0] : $value[1]}
                    </WemoloTypography>
                )
            }}
        />
    )
}
